export const APPOINTMENT_STATUS_PENDING_TO_ATTEND = 'appointment_status_pending_to_attend';
export const APPOINTMENT_STATUS_TECHNICIAN_ASSIGNED = 'appointment_status_technician_assigned';
export const APPOINTMENT_STATUS_TECHNICIAN_ON_THE_WAY = 'appointment_status_technician_on_the_way';
export const APPOINTMENT_STATUS_WAITING_CUSTOMER = 'appointment_status_waiting_customer';
export const APPOINTMENT_STATUS_CANCELED_BY_TECHNICIAN = 'appointment_status_cancelled_by_technician';
export const APPOINTMENT_STATUS_IN_PROGRESS = 'appointment_status_in_progress';
export const APPOINTMENT_STATUS_WORKING_ON_IT = 'appointment_status_working_on_it';
export const APPOINTMENT_STATUS_WORK_PAYMENT_PENDING = 'appointment_status_work_payment_pending';
export const APPOINTMENT_STATUS_WORK_FINISHED = 'appointment_status_work_finished';

export function getStatusText(status) {
    switch (status) {
        case APPOINTMENT_STATUS_PENDING_TO_ATTEND: {
            return 'Pending to attend'
        }
        case APPOINTMENT_STATUS_TECHNICIAN_ASSIGNED: {
            return 'Technician assigned'
        }
        case APPOINTMENT_STATUS_TECHNICIAN_ON_THE_WAY: {
            return 'Technician on the way'
        }
        case APPOINTMENT_STATUS_WAITING_CUSTOMER: {
            return 'Waiting customer'
        }
        case APPOINTMENT_STATUS_CANCELED_BY_TECHNICIAN: {
            return 'Canceled by technician';
        }
        case APPOINTMENT_STATUS_IN_PROGRESS: {
            return 'In progress';
        }
        case APPOINTMENT_STATUS_WORKING_ON_IT: {
            return 'Working on it';
        }
        case APPOINTMENT_STATUS_WORK_PAYMENT_PENDING: {
            return 'Payment pending'
        }
        case APPOINTMENT_STATUS_WORK_FINISHED: {
            return 'APPOINTMENT FINISHED'
        }
        default: {
            return '';
        }
    }
}

export function isCancelledByCustomer(status) {

}
